// TODO - move this definitions to correct folder/files
import {isRiver} from "./constants";
import {numbersListRegex, numbersRangesListRegex} from "../utils/validationUtils";

export const problemListFields = [
    {
        key: "creationDateTime",
        header: "Created on",
        sortable: true,
        filter: false,
        customSort:{
            type: "date",
            field: "creationDateTime",
        },
    },
    {
        key: "customerName",
        header: "Customer name",
        sortable: true,
        filter: true,
    },
    {
        key: "location",
        header: "Cabin",
        sortable: true,
        filter: true,
    },
    {
        key: "problemCategory.name.defaultValue",
        header: "Category",
        sortable: true,
        filter: true,
    },
    {
        key: "status",
        header: "Status",
        sortable: true,
        filter: true,
        format: "camelAsTitleCase",
    },

    {
        key: "customerCallRequired",
        header: "Call",
        sortable: true,
        filter: false,
        format: "boolean",
    },
];


export const problemFormFields = [
    {
        name: "customerName",
        label: "Passenger name",
        type: "text",
        defaultValue: "",
        readOnly: true,
    },
    {
        name: "location",
        label: "Cabin number",
        type: "autocomplete",
        url: "pms/passengers?location=",
        minLength: isRiver() ? 3 : 4,
        defaultValue: "",
        fields: {
            pmsUniqueId: "entityId",
            location: "location",
            customerName: "name",
        },
        hideOnEdit: true,
        validation: ['required', 'numeric'],
    },
    {
        name: "pmsUniqueId",
        label: "entity id",
        type: "text",
        defaultValue: "",
        hidden: true,
        validation: ['required', 'numeric'],
    },
    {
        name: "problemCategory",
        label: "Category",
        type: "dropdown-basic",
        optionsKey: "categories",
        defaultValue: {id: ""},
        validation: ['required','dropdown-basic'],
    },
    {
        name: "description",
        label: "Problem Description",
        type: "textarea",
        defaultValue: "",
        validation: ['required'],
    },
    {
        name: "publish",
        label: "Publish Problem to Customer",
        type: "switch",
        defaultValue: false,
    },
    {
        name: "customerCallRequired",
        label: "Follow up call required",
        type: "switch",
        defaultValue: false,
    },
    {
        name: "status",
        label: "Status",
        type: "dropdown-enum",
        optionsKey: "states",
        defaultValue: "",
        validation: ['required-dropdown'],
    },
    {
        name: "solution",
        label: "Solution",
        type: "textarea",
        defaultValue: "",
        validation: ['required-if;status;Resolved|Unresolved']
    },
    {
        name: "staffName",
        label: "Staff contact",
        type: "text",
        defaultValue: "",
    },
];

export const demoListFields = [
    {
        key: "id",
        header: "ID",
        sortable: true,
        filter: false,
    },
    {
        key: "name",
        header: "Name",
        sortable: true,
        filter: true,
    },
];


export const demoFormFields = [
    {
        name: "id",
        label: "ID",
        type: "text",
        defaultValue: "",
        validation: ['required', 'numeric'],
    },
    {
        name: "name",
        label: "Name",
        type: "text",
        defaultValue: "",
        validation: ['required'],
    },
];


export const digitalSignageConfigurationFormFields = [
    {
        name: "appUrl",
        label: "App URL",
        type: "text",
        defaultValue: "",
        validation: ['required'],
    },
    // TODO - change mode field to be dropdown with predefined options list
    {
        name: "presentationMode",
        label: "Mode",
        type: "text",
        defaultValue: "",
        validation: ['required'],
    },
];

export const cabinMessageGroupListFields = [
    {
        key: "groupName.values.en",
        header: "Group name",
        sortable: true,
        filter: true,
    },
    {
        key: "groupDescription.values.en",
        header: "Group description",
        sortable: true,
        filter: true,
    },
    {
        key: "broadcastToAllDecks",
        header: "All decks",
        sortable: true,
        filter: false,
        format: "boolean",
    },
    {
        key: "deckNumbers",
        header: "Deck numbers",
        filter: true,
    },
    {
        key: "cabinRanges",
        header: "Cabin ranges",
        filter: true,
    },
    {
        key: "cabinNumbers",
        header: "Cabin numbers",
        filter: true,
    },
]

export const cabinMessageGroupFormFields = [
    {
        name: "groupName",
        label: "Group name",
        type: "multiLangText",
        defaultValue: {values: {en: ""}},
        validation: ['required-multilang-en'],
    },
    {
        name: "groupDescription",
        label: "Group description",
        type: "multiLangText",
        defaultValue: {values: {en: ""}},
        validation: ['required-multilang-en'],
    },
    {
        name: "broadcastToAllDecks",
        label: "All decks",
        type: "switch",
        defaultValue: false,
    },
    {
        name: "deckNumbers",
        label: "Decks",
        type: "text",
        defaultValue: "",
        validation: [`regex;${numbersListRegex}`],
    },
    {
        name: "cabinRanges",
        label: "Cabin ranges",
        type: "text",
        defaultValue: "",
        validation: [`regex;${numbersRangesListRegex}`],
    },
    {
        name: "cabinNumbers",
        label: "Cabins numbers",
        type: "text",
        defaultValue: "",
        validation: [`regex;${numbersListRegex}`],
    },
]

export const cabinMessagesTableFields = [
    {
        key: "createdAt",
        header: "Created on",
        format: "timestampForHumans",
        sortable: true,
        filter: false,
    },
    {
        key: "sourceMessageTitle.en",
        header: "Message title",
        sortable: true,
        filter: true,
    },
    {
        key: "sourceMessageContent.en",
        header: "Message Content",
        sortable: true,
        filter: true,
    },
    {
        key: "sourceMessageType",
        header: "Message type",
        sortable: true,
        filter: true,
    },
    {
        key: "broadcastToAllCabin",
        header: "All cabins",
        sortable: true,
        format: "boolean",
    },
    {
        key: "totalNumberOfRecipient",
        header: "Count",
        sortable: true,
    },
    {
        key: "totalNumberOfReadReceiptReceived",
        header: "Read",
        sortable: true,
    },
]

export const excursionBookingTableFields = [
  {
    key: "date",
    header: "Booking Date",
    sortable: true,
    format: "timestampForHumans"
  },
  {
    key: "accountNumber",
    header: "Acc Nr",
    sortable: true,
  },
  {
    key: "cabinNumber",
    header: "Cabin Nr",
    sortable: true,
  },
  {
    key: "firstName",
    header: "First Name",
    sortable: true,
  },
  {
    key: "lastName",
    header: "Last Name",
    sortable: true,
  },
  {
    key: "excursionName",
    header: "Excursion",
    sortable: true,
    format: "truncateString",
  },
  {
    key: "bookingCode",
    header: "Booking Code",
    sortable: true,
  },
  {
    key: "syncStatus",
    header: "Synced",
    sortable: true,
    format: "boolean",
    formatOptions:{
        valueforYes:"Synced"
    }
  },
  {
    key: "state",
    header: "State",
    format: "camelAsTitleCase",
    sortable: true,
  },
  {
    key: "action",
    header: "Action",
    sortable: false,
    format: "jsx",
    formatOptions:{
        requireRowData: true
    }
  },
];

export const eventsTableFields = [
    {
        key: "startDate",
        header: "Start Date",
        sortable: true,
    },
    {
        key: "timings",
        header: "Timings",
        sortable: false,
        classNames: "min-w-32",
        format: "jsx",
        formatOptions:{
            requireRowData: false
        }
    },
    {
        key: "name",
        header: "Event",
        sortable: true,
        format: "jsx",
        formatOptions:{
            requireRowData: false
        }
    },
    {
        key: "venue",
        header: "Venue",
        sortable: true,
        format: "jsx",
        formatOptions:{
            requireRowData: false
        }
    },
    {
        key: "noOfBookmarks",
        header: "nr Bookmarks",
        sortable: true,
    }
  ];

export const eventBookingsTableFields = [
    {
        key: "pmsAccountNumber",
        header: "Account",
        sortable: false,
    },
    {
        key: "cabinNumber",
        header: "Cabin",
        sortable: false,
    },
    {
        key: "paxName",
        header: "Passenger",
        sortable: false,
    }
];

export const trustedDevicesTableFields = [
    {
        key: "device",
        header: "Device",
        sortable: true
    },
    {
        key: "ipAddress",
        header: "IP Address",
        sortable: true
    },
    {
        key: "lastUsed",
        header: "Last Used",
        sortable: true
    },
    {
        key: "expiration",
        header: "Expires",
        sortable: true
    },
    {
        key: "actions",
        header: "Actions",
        format: "jsx",
        sortable: false
    },
];